export const US_REGIONS: Record<string, { name: string; slug: string }> = {
  AL: { name: 'Alabama', slug: 'alabama' },
  AK: { name: 'Alaska', slug: 'alaska' },
  AZ: { name: 'Arizona', slug: 'arizona' },
  AR: { name: 'Arkansas', slug: 'arkansas' },
  CA: { name: 'California', slug: 'california' },
  CO: { name: 'Colorado', slug: 'colorado' },
  CT: { name: 'Connecticut', slug: 'connecticut' },
  DE: { name: 'Delaware', slug: 'delaware' },
  FL: { name: 'Florida', slug: 'florida' },
  GA: { name: 'Georgia', slug: 'georgia' },
  HI: { name: 'Hawaii', slug: 'hawaii' },
  ID: { name: 'Idaho', slug: 'idaho' },
  IL: { name: 'Illinois', slug: 'illinois' },
  IN: { name: 'Indiana', slug: 'indiana' },
  IA: { name: 'Iowa', slug: 'iowa' },
  KS: { name: 'Kansas', slug: 'kansas' },
  KY: { name: 'Kentucky', slug: 'kentucky' },
  LA: { name: 'Louisiana', slug: 'louisiana' },
  ME: { name: 'Maine', slug: 'maine' },
  MD: { name: 'Maryland', slug: 'maryland' },
  MA: { name: 'Massachusetts', slug: 'massachusetts' },
  MI: { name: 'Michigan', slug: 'michigan' },
  MN: { name: 'Minnesota', slug: 'minnesota' },
  MS: { name: 'Mississippi', slug: 'mississippi' },
  MO: { name: 'Missouri', slug: 'missouri' },
  MT: { name: 'Montana', slug: 'montana' },
  NE: { name: 'Nebraska', slug: 'nebraska' },
  NV: { name: 'Nevada', slug: 'nevada' },
  NH: { name: 'New Hampshire', slug: 'new-hampshire' },
  NJ: { name: 'New Jersey', slug: 'new-jersey' },
  NM: { name: 'New Mexico', slug: 'new-mexico' },
  NY: { name: 'New York', slug: 'new-york' },
  NC: { name: 'North Carolina', slug: 'north-carolina' },
  ND: { name: 'North Dakota', slug: 'north-dakota' },
  OH: { name: 'Ohio', slug: 'ohio' },
  OK: { name: 'Oklahoma', slug: 'oklahoma' },
  OR: { name: 'Oregon', slug: 'oregon' },
  PA: { name: 'Pennsylvania', slug: 'pennsylvania' },
  RI: { name: 'Rhode Island', slug: 'rhode-island' },
  SC: { name: 'South Carolina', slug: 'south-carolina' },
  SD: { name: 'South Dakota', slug: 'south-dakota' },
  TN: { name: 'Tennessee', slug: 'tennessee' },
  TX: { name: 'Texas', slug: 'texas' },
  UT: { name: 'Utah', slug: 'utah' },
  VT: { name: 'Vermont', slug: 'vermont' },
  VA: { name: 'Virginia', slug: 'virginia' },
  WA: { name: 'Washington', slug: 'washington' },
  WV: { name: 'West Virginia', slug: 'west-virginia' },
  WI: { name: 'Wisconsin', slug: 'wisconsin' },
  WY: { name: 'Wyoming', slug: 'wyoming' },
  DC: { name: 'District of Columbia', slug: 'district-of-columbia' }
}
export const DE_REGIONS: Record<string, { name: string; slug: string }> = {
  BW: { name: 'Baden-Württemberg', slug: 'baden-wuerttemberg' },
  BY: { name: 'Bayern', slug: 'bayern' },
  BE: { name: 'Berlin', slug: 'berlin' },
  BB: { name: 'Brandenburg', slug: 'brandenburg' },
  HB: { name: 'Bremen', slug: 'bremen' },
  HH: { name: 'Hamburg', slug: 'hamburg' },
  HE: { name: 'Hessen', slug: 'hessen' },
  MV: { name: 'Mecklenburg-Vorpommern', slug: 'mecklenburg-vorpommern' },
  NI: { name: 'Niedersachsen', slug: 'niedersachsen' },
  NW: { name: 'Nordrhein-Westfalen', slug: 'nordrhein-westfalen' },
  RP: { name: 'Rheinland-Pfalz', slug: 'rheinland-pfalz' },
  SL: { name: 'Saarland', slug: 'saarland' },
  SN: { name: 'Sachsen', slug: 'sachsen' },
  ST: { name: 'Sachsen-Anhalt', slug: 'sachsen-anhalt' },
  SH: { name: 'Schleswig-Holstein', slug: 'schleswig-holstein' },
  TH: { name: 'Thüringen', slug: 'thueringen' }
}
export const GB_REGIONS: Record<string, { name: string; slug: string }> = {
  ENG: { name: 'England', slug: 'england' },
  WAL: { name: 'Wales', slug: 'wales' },
  SCO: { name: 'Scotland', slug: 'scotland' },
  NIR: { name: 'Northern Ireland', slug: 'northern-ireland' }
}
export const CA_REGIONS: Record<string, { name: string; slug: string }> = {
  AB: { name: 'Alberta', slug: 'alberta' },
  BC: { name: 'British Columbia', slug: 'british-columbia' },
  MB: { name: 'Manitoba', slug: 'manitoba' },
  NB: { name: 'New Brunswick', slug: 'new-brunswick' },
  NL: { name: 'Newfoundland and Labrador', slug: 'newfoundland-and-labrador' },
  NS: { name: 'Nova Scotia', slug: 'nova-scotia' },
  NT: { name: 'Northwest Territories', slug: 'northwest-territories' },
  NU: { name: 'Nunavut', slug: 'nunavut' },
  ON: { name: 'Ontario', slug: 'ontario' },
  PE: { name: 'Prince Edward Island', slug: 'prince-edward-island' },
  QC: { name: 'Quebec', slug: 'quebec' },
  SK: { name: 'Saskatchewan', slug: 'saskatchewan' },
  YT: { name: 'Yukon', slug: 'yukon' }
}
export const IN_REGIONS: Record<string, { name: string; slug: string }> = {
  AP: { name: 'Andhra Pradesh', slug: 'andhra-pradesh' },
  AS: { name: 'Assam', slug: 'assam' },
  BR: { name: 'Bihar', slug: 'bihar' },
  CG: { name: 'Chhattisgarh', slug: 'chhattisgarh' },
  GJ: { name: 'Gujarat', slug: 'gujarat' },
  JH: { name: 'Jharkhand', slug: 'jharkhand' },
  KA: { name: 'Karnataka', slug: 'karnataka' },
  KL: { name: 'Kerala', slug: 'kerala' },
  MH: { name: 'Maharashtra', slug: 'maharashtra' },
  ML: { name: 'Meghalaya', slug: 'meghalaya' },
  MP: { name: 'Madhya Pradesh', slug: 'madhya-pradesh' },
  MN: { name: 'Manipur', slug: 'manipur' },
  NL: { name: 'Nagaland', slug: 'nagaland' },
  OD: { name: 'Odisha', slug: 'odisha' },
  SK: { name: 'Sikkim', slug: 'sikkim' },
  TN: { name: 'Tamil Nadu', slug: 'tamil-nadu' },
  TS: { name: 'Telangana', slug: 'telangana' },
  TR: { name: 'Tripura', slug: 'tripura' },
  WB: { name: 'West Bengal', slug: 'west-bengal' },
  AR: { name: 'Arunachal Pradesh', slug: 'arunachal-pradesh' },
  GA: { name: 'Goa', slug: 'goa' },
  HR: { name: 'Haryana', slug: 'haryana' },
  HP: { name: 'Himachal Pradesh', slug: 'himachal-pradesh' },
  MZ: { name: 'Mizoram', slug: 'mizoram' },
  PB: { name: 'Punjab', slug: 'punjab' },
  RJ: { name: 'Rajasthan', slug: 'rajasthan' },
  UP: { name: 'Uttar Pradesh', slug: 'uttar-pradesh' },
  UK: { name: 'Uttarakhand', slug: 'uttarakhand' },
  AN: { name: 'Andaman and Nicobar Islands', slug: 'andaman-nicobar' },
  CH: { name: 'Chandigarh', slug: 'chandigarh' },
  DN: { name: 'Dadra and Nagar Haveli', slug: 'dadra-nagar-haveli' },
  DL: { name: 'Delhi', slug: 'delhi' },
  JK: { name: 'Jammu and Kashmir', slug: 'jammu-kashmir' },
  LA: { name: 'Ladakh', slug: 'ladakh' },
  LD: { name: 'Lakshadweep', slug: 'lakshadweep' },
  PY: { name: 'Puducherry', slug: 'puducherry' }
}
export function getRegionsForCountry(countryCode: string): Record<string, { name: string; slug: string }> {
  switch (countryCode) {
    case 'DE': return DE_REGIONS
    case 'IN': return IN_REGIONS
    case 'GB': return GB_REGIONS
    case 'CA': return CA_REGIONS
    default: return US_REGIONS
  }
}
export function regionCodeToSlug(code: string, countryCode: string = 'US'): string {
  const regions = getRegionsForCountry(countryCode)
  return regions[code.toUpperCase()]?.slug || code.toLowerCase()
}
export function slugToRegionCode(slug: string, countryCode: string = 'US'): string | null {
  const regions = getRegionsForCountry(countryCode)
  const normalizedSlug = slug.toLowerCase()
  for (const [code, region] of Object.entries(regions)) {
    if (region.slug.toLowerCase() === normalizedSlug) {
      return code
    }
  }
  if (regions[slug.toUpperCase()]) {
    return slug.toUpperCase()
  }
  return null
}
export function getDefaultRegionSlug(countryCode: string): string {
  switch (countryCode) {
    case 'DE': return 'berlin'
    case 'IN': return 'maharashtra'
    case 'GB': return 'england'
    case 'CA': return 'ontario'
    default: return 'new-york'
  }
}
export function getDefaultRegionCode(countryCode: string): string {
  switch (countryCode) {
    case 'DE': return 'BE'
    case 'IN': return 'MH'
    case 'GB': return 'ENG'
    case 'CA': return 'ON'
    default: return 'NY'
  }
}
export function regionSlugToCode(slug: string, countryCode: string = 'US'): string {
  return slugToRegionCode(slug, countryCode) || ''
}
export function isValidRegionSlug(slug: string, countryCode: string = 'US'): boolean {
  const regions = getRegionsForCountry(countryCode)
  const normalizedSlug = slug.toLowerCase()
  for (const region of Object.values(regions)) {
    if (region.slug.toLowerCase() === normalizedSlug) {
      return true
    }
  }
  return false
}
export function getRegionBySlug(slug: string, countryCode: string = 'US'): { code: string; name: string; slug: string } | null {
  const regions = getRegionsForCountry(countryCode)
  const normalizedSlug = slug.toLowerCase()
  for (const [code, region] of Object.entries(regions)) {
    if (region.slug.toLowerCase() === normalizedSlug) {
      return { code, name: region.name, slug: region.slug }
    }
  }
  return null
}